import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IAutomationService from "../contracts/IAutomationService";
import AutomationService from "../services/AutomationService";
import type NodeDescriptor from "../models/NodeDescriptor";

const automationService: IAutomationService = new AutomationService();

export function useNodeCatalog() {
  const { loading, error, execute } = useAsync();

  const getCatalog = useCallback(async (): Promise<NodeDescriptor[] | void> => {
    return await execute(() => automationService.GetNodeCatalog());
  }, [execute]);

  return { loading, error, getCatalog };
}
